import { useQuery } from "@tanstack/react-query";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { PageEditor, PageNotFound } from "@/components/page-editor";
import {
  adminPagesQuery,
  PagesWorkspace,
} from "@/components/pages/pages-workspace";

const routeApi = getRouteApi("/admin/pages/$name");

const EditPage = () => {
  const { name } = routeApi.useParams();
  const pages = useQuery(adminPagesQuery());
  const pageName = decodeURIComponent(name);
  const page = pages.data?.find((it) => it.name === pageName);

  return (
    <PagesWorkspace activeId={page?.id ?? pageName}>
      {pages.isPending && (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
      {pages.isSuccess && !page && <PageNotFound />}
      {page && <PageEditor key={page.id} page={page} />}
    </PagesWorkspace>
  );
};

export const Route = createFileRoute("/admin/pages/$name")({
  component: EditPage,
});
